import React from 'react';
import { ImageIcon } from 'lucide-react';

const GALLERY_IMAGES = [
  {
    id: 1,
    src: 'https://jalwaaamazingg.site.pro/gallery/assets-img-proof1.webp?ts=1770386928',
    alt: 'Gallery 1',
  },
  {
    id: 2,
    src: 'https://jalwaaamazingg.site.pro/gallery/assets-img-proof2.webp?ts=1770386928',
    alt: 'Gallery 2',
  },
  {
    id: 3,
    src: 'https://jalwaaamazingg.site.pro/gallery/assets-img-proof1.webp?ts=1770386928',
    alt: 'Gallery 3',
  },
  {
    id: 4,
    src: 'https://jalwaaamazingg.site.pro/gallery/assets-img-proof2.webp?ts=1770386928',
    alt: 'Gallery 4',
  },
];

// Section header component
const FeedbackHeader = () => (
  <div className="text-center mb-12">
    <div className="flex items-center justify-center mb-4">
      <ImageIcon className="h-8 w-8 text-blue-500 mr-3" />
      <h2 className="text-3xl md:text-4xl font-bold text-white">Feedback</h2>
    </div>
  </div>
);

// Gallery item component
const GalleryItem = ({ image, index }) => (
  <div
    className="relative group overflow-hidden rounded-2xl shadow-lg shadow-blue-500/20 hover:shadow-2xl hover:shadow-blue-500/40 transition-all duration-500 transform hover:scale-105 border border-gray-800"
    style={{
      animationDelay: `${index * 100}ms`,
    }}
  >
    <img
      src={image.src}
      alt={image.alt}
      className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-blue-600/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
  </div>
);

const FeedbackSection = () => {
  return (
    <section className="py-12 md:py-20 px-4 bg-black">
      <div className="container mx-auto max-w-6xl">
        <FeedbackHeader />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {GALLERY_IMAGES.map((image, index) => (
            <GalleryItem key={image.id} image={image} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeedbackSection;
